import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from '../../store/vplstore';
import { ItemEditBtns } from '../../services/itemeditbtns/itemeditbtns';

export const PhoneFooterTwo = {
    components: {
        ItemEditBtns
    },
    props: {
        tagClass: String
    },
    methods: {
        clearPhone(phone){
            phone = phone.replace(/[^0-9+]/g,'');
            return 'tel:' + phone;
        }
    },
    computed: {
        ...mapState(vplSiteStore, ['templateData'])
    },
    template: `
            <ItemEditBtns  v-if="templateData && templateData.phone && templateData.phone.EDIT_BUTTON" :onclick="templateData.phone.EDIT_BUTTON">
                Редактировать телефон
            </ItemEditBtns>
            <a  v-if="templateData && templateData.phone && templateData.phone.CONTENT"
                :href="clearPhone(templateData.phone.CONTENT)"
                class="contacts-socials__tel js-copyphone"
                >
                <span class="footer__contact-icon" aria-hidden="true">
                    <svg class="icon" width="18" height="18"><use xlink:href="#footer-phone"></use></svg>
                </span>
                <span class="footer__contact-text">
                    <span class="footer__contact-value">{{ templateData.phone.CONTENT }}</span>
                    <span class="footer__contact-note">Ежедневно с 9:00 до 18:00</span>
                </span>
            </a>
    `
}